module.exports = __webpack_public_path__ + "img/Digital Products_Poster_BlueBOT.8dcdd042.jpg";